import axios from 'axios'

export default (sql) => {
  const body = {
    data: sql,
    keywords_case: 'upper',
    identifier_case: 'capitalize',
    n_indents: 2,
    output_format: 'sql',
    ajax: 1,
    highlight: 1
  }
  // Fluxo do connect utilizado para circular a limitação de tamanho no valor da URL Param da API que formata SQL.
  return axios.post('https://seniorconnect.com.br:9010/senior/workflowrest/sql-formatter', body)
}
